/**
 * Module dependencies.
 */

import NextImage, { ImageProps as NextImageProps } from 'next/image';

/**
 * Export `ImageProps` type.
 */

export type ImageProps = NextImageProps & {
  className?: string;
};

/**
 * Export `Image` component.
 */

export const Image = (props: ImageProps) => <NextImage {...props} />;
